import React, { useRef ,useState , useEffect } from 'react';
import './App.css';


import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Pricacypolicy from './Privacypolicy';
import Termscondition from './Termscondition';
import Main from './Main';
import Loader from './components/Loader';
import ScrollToTop from './components/ScrollToTop';



function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate data fetching
    setTimeout(() => setLoading(false), 2500);
  }, []);

  if (loading) return <Loader />;

  return (
    <div className=''>
      <Router >
        <ScrollToTop />
        <Routes>
          <Route path='/' element={<Main />} />
          <Route path="/privacy-policy" element={< Pricacypolicy />} />
          <Route path="/terms-and-conditions" element={<Termscondition />} />
        </Routes>
      </Router>



    </div>
  );
}

export default App;